import NullState from './NullState';

export default NullState;
